module.exports = "/_next/static/images/d649900b3fb7a690a746a77d36144015-holding-device-smile@3x.jpg";